import { Select, Store } from '@ngxs/store';
import { combineLatest, map, Observable } from 'rxjs';
import { AppInfoState } from 'src/app/states/app-info.state';
import { inject, Injectable } from '@angular/core';
import { FOOTER_LINKS } from '../../tokens/footer-links.token';
import { FooterLink } from '../../models/footer-link';
import { AuthState } from 'src/states/auth/state/auth.state';
import { IFooterService } from './footer.service.interface';
import { ShowDownloadsModal, ShowFormsModal, ShowPhlebotomyModal } from 'src/app/states/actions/modal.actions';
import { LoginClaimsState } from 'src/modules/security/states/login-claims/login-claims.state';
import { UserRole } from 'src/modules/security/enums/user-role.enum';

@Injectable()
export class FooterService implements IFooterService {
  private readonly links = inject(FOOTER_LINKS);
  private readonly store = inject(Store);

  @Select(AppInfoState.appVersion) public appVersion$!: Observable<string>;
  @Select(AuthState.loggedIn) public loggedIn$!: Observable<boolean>;
  @Select(LoginClaimsState.role) public currentRole$!: Observable<UserRole | undefined>;

  public appVersionValue$: Observable<string> = this.appVersion$;
  public loggedInValue$: Observable<boolean> = this.loggedIn$;
  public links$: Observable<FooterLink[]> = combineLatest([this.currentRole$, this.loggedInValue$]).pipe(
    map(([userType, loggedIn]) => {
      return this.links.filter((link: FooterLink) => {
        if (link.loggedOutOnly && loggedIn) {
          return false;
        }
        const login = link.loginRequired ? loggedIn : true;
        const userTypeMatch = link.userType !== undefined ? userType === link.userType : true;
        return login && userTypeMatch;
      });
    })
  );

  public openDialog(link: FooterLink): void {
    switch (link.name) {
      case 'Forms':
        this.formsDialog();
        break;
      case 'Phlebotomy':
        this.phlebotomyDialog();
        break;
      case 'Downloads':
        this.downloadsDialog();
        break;
    }
  }

  public formsDialog(): void {
    this.store.dispatch(new ShowFormsModal());
  }

  public phlebotomyDialog(): void {
    this.store.dispatch(new ShowPhlebotomyModal());
  }

  public downloadsDialog(): void {
    this.store.dispatch(new ShowDownloadsModal());
  }
}
